import { memo } from 'react';
import { useSelector } from 'react-redux';

import { MobileHeader, type MobileHeaderProps } from '~/components/AssetModal/components/MobileHeader';
import { centralizedPublicClipBoardInfoSelector } from '~/store/centralizedClip/selectors';

/** Public asset modals: "in {board}" comes from the URL board. */
export type PublicMobileHeaderProps = Omit<MobileHeaderProps, 'boardInfo'>;

export const PublicMobileHeader = memo(({ onClose, onUpdateTitle }: PublicMobileHeaderProps) => {
  const boardInfo = useSelector(centralizedPublicClipBoardInfoSelector);

  return <MobileHeader boardInfo={boardInfo} onClose={onClose} onUpdateTitle={onUpdateTitle} />;
});

PublicMobileHeader.displayName = 'PublicMobileHeader';
